import api from '../../../services/Api';
import { IAuditoriaPayrollDriftResultado } from '../interfaces/IAuditoriaPayrollDrift';

export const AuditoriaPayrollDriftService = {
  buscarResultado: async (params: { empresaId: number; periodo: string | undefined })
    : Promise<IAuditoriaPayrollDriftResultado> => {
    const response = await api.get<IAuditoriaPayrollDriftResultado>(
      'auditoria-payroll-drift/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
